import Link from 'next/link';

type Props = {
  text: string;
  buttonText1: string;
  buttonText2: string;
};

export default function QuoteCTABlock({
  text,
  buttonText1,
  buttonText2,
}: Props) {
  return (
    <section className="bg-secondary py-24 text-white">
      <div className="mx-auto flex max-w-7xl flex-col items-center px-6 text-center lg:flex-row lg:text-left">
        <div className="text-r-3xl font-bold">{text}</div>
        <div className="mt-8 flex shrink-0 flex-col items-center space-y-4 md:flex-row md:space-y-0 md:space-x-4 lg:ml-8 lg:mt-0">
          <Link passHref href="/contact">
            <a className="btn-secondary">{buttonText1}</a>
          </Link>
          <Link href="/demo">
            <a className="btn-primary">{buttonText2}</a>
          </Link>
        </div>
      </div>
    </section>
  );
}
